import styled from 'styled-components';

import { grey3 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const GifView = styled.div`
  background-color: ${grey3};
  border-radius: ${rem(borderRadius8)};
  height: 100%;
`;
